var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4'),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('LanguageSelect')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }